import React from 'react'
import ReminderTask from './Task'
import ReminderUser from './User'
import ReminderArticle from './Article'
import ReminderSession from './Session'

export type ReminderItemProps = Pick<APIReminder, 'object_id' | 'object_type'>

const ELEMENT_MAP: Record<APIReminder['object_type'], React.FC<any>> = {
  task: ReminderTask,
  user: ReminderUser,
  article: ReminderArticle,
  session: ReminderSession
}

const ReminderItem: React.FC<ReminderItemProps> = props => {
  const Element = React.useMemo(() => {
    const fieldType = props.object_type

    if (fieldType in ELEMENT_MAP) {
      return ELEMENT_MAP[fieldType]
    }

    console.warn(`Unknown reminder type: ${fieldType}`)
    return null
  }, [props.object_type])

  if (!Element) {
    return null
  }

  return <Element {...props} />
}

export default ReminderItem
